var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"height":"30px","width":"auto"},attrs:{"src":require("@/assets/images/logo/flipmoney.png")}})])}]

export { render, staticRenderFns }